export enum AnesthesiaMethodCategory {
  XY = "01",
  ZC = "02",
  ZY = "03",
  ZCF = "04",
  ZLF = "05",
  JCF = "06",
  HYF = "07",
  SSF = "08",
  FSF = "09",
  SXF = "10",
  SYF = "11",
  CLF = "17",
  BCF = "23",
  XDTF = "24",
  ZSF = "25",
  TXF = "26",
  HLF = "27",
  MZF = "28",
  GHF = "30",
  XL = "32",
  FL = "33",
  HLFF = "34",
  DJF = "97",
  QTF = "99",
}
// 全部
export const BillingCategories = [
  AnesthesiaMethodCategory.XY,
  AnesthesiaMethodCategory.ZC,
  AnesthesiaMethodCategory.ZY,
  AnesthesiaMethodCategory.ZCF,
  AnesthesiaMethodCategory.ZLF,
  AnesthesiaMethodCategory.JCF,
  AnesthesiaMethodCategory.HYF,
  AnesthesiaMethodCategory.SSF,
  AnesthesiaMethodCategory.FSF,
  AnesthesiaMethodCategory.SXF,
  AnesthesiaMethodCategory.SYF,
  AnesthesiaMethodCategory.CLF,
  AnesthesiaMethodCategory.BCF,
  AnesthesiaMethodCategory.XDTF,
  AnesthesiaMethodCategory.ZSF,
  AnesthesiaMethodCategory.TXF,
  AnesthesiaMethodCategory.HLF,
  AnesthesiaMethodCategory.MZF,
  AnesthesiaMethodCategory.GHF,
  AnesthesiaMethodCategory.XL,
  AnesthesiaMethodCategory.FL,
  AnesthesiaMethodCategory.DJF,
  AnesthesiaMethodCategory.QTF,
];

// 医技站设置可执行开票项目
export const YJZSettingCategories = [
  AnesthesiaMethodCategory.ZLF,
  AnesthesiaMethodCategory.JCF,
  AnesthesiaMethodCategory.HYF,
  AnesthesiaMethodCategory.SSF,
  AnesthesiaMethodCategory.FSF,
  AnesthesiaMethodCategory.SXF,
  AnesthesiaMethodCategory.SYF,
  AnesthesiaMethodCategory.BCF,
  AnesthesiaMethodCategory.XDTF,
  AnesthesiaMethodCategory.ZSF,
  AnesthesiaMethodCategory.TXF,
  AnesthesiaMethodCategory.HLF,
  AnesthesiaMethodCategory.MZF,
  AnesthesiaMethodCategory.HLFF,
  AnesthesiaMethodCategory.QTF,
];

export function AnesthesiaMethodCategoryName(anesthesiaMethodCategory: AnesthesiaMethodCategory): string {
  switch (anesthesiaMethodCategory) {
    case "01":
      return "西药费";
    case "02":
      return "中成药";
    case "03":
      return "中草药";
    case "04":
      return "诊查费";
    case "05":
      return "治疗费";
    case "06":
      return "检查费";
    case "07":
      return "化验费";
    case "08":
      return "手术费";
    case "09":
      return "放射费";
    case "10":
      return "输血费";
    case "11":
      return "输氧费";
    case "17":
      return "材料费";
    case "23":
      return "B超费";
    case "24":
      return "心电图费";
    case "25":
      return "注射费";
    case "26":
      return "透析费";
    case "27":
      return "化疗费";
    case "28":
      return "麻醉费";
    case "30":
      return "挂号费";
    case "32":
      return "细料";
    case "33":
      return "辅料";
    case "34":
      return "护理费";
    case "97":
      return "代煎费";
    case "99":
      return "其他费";
  }
  return "";
}
